import request from '@/sheep/request';

// 自律项选项值
export interface LimitFieldOption {
	id : number
	fieldId ?: number
	optionValue ?: string
	sort ?: number
	unitName ?: string
	createTime ?: any
}

// 创建自律项选项值
export const createLimitFieldOption = async (data : Partial<LimitFieldOption>) => {
	return request({
		url: '/wish/limit-field-option/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 更新自律项选项值
export const updateLimitFieldOption = async (data : Partial<LimitFieldOption>) => {
	return request({
		url: '/wish/limit-field-option/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项选项值
export const deleteLimitFieldOption = async (id : number) => {
	return request({
		url: '/wish/limit-field-option/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项选项值
export const deleteLimitFieldOptionList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-field-option/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项选项值
export const getLimitFieldOption = async (id : number) => {
	return request({
		url: '/wish/limit-field-option/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得自律项选项值分页
export const getLimitFieldOptionPage = async (params : any) => {
	return request({
		url: '/wish/limit-field-option/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}
